import type { WidgetSource } from "./types";

export const OFFICIAL_SOURCE_HOSTS = new Set(["test.lpude.in"]);

/**
 * Accepts only HTTPS links on exact reviewed LPU DE hosts.
 */
export function isOfficialSourceUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return (
      url.protocol === "https:" &&
      !url.username &&
      !url.password &&
      OFFICIAL_SOURCE_HOSTS.has(url.hostname.toLowerCase())
    );
  } catch {
    return false;
  }
}

/**
 * Clamps presentation-safe official sources and rejects lookalike domains.
 */
export function sanitizeOfficialSources(
  sources: WidgetSource[],
  limit = 1,
): WidgetSource[] {
  return sources
    .filter((source) => isOfficialSourceUrl(source.url))
    .slice(0, Math.min(1, Math.max(0, limit)))
    .map((source) => ({
      url: source.url.slice(0, 1_000),
      ...(source.title ? { title: source.title.slice(0, 40) } : {}),
    }));
}
